import {isNil, isNotNil} from 'ramda';

import {useGetBranchQuery} from '@dms/api/core';
import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import {
  useGetServiceVehicleHomeBranchQuery,
  usePutServiceVehicleHomeBranchMutation,
} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

import {handleApiError} from '../../../utils/handleApiError';
import {BranchChanger} from './BranchChanger';

export interface ServiceBranchProps extends TestIdProps {
  recordId: string;
}

export function ServiceBranch(props: ServiceBranchProps) {
  const {data: currentUserInfo} = useGetCurrentUserInfoQuery();

  const homeBranchQuery = useGetServiceVehicleHomeBranchQuery({vehicleId: props.recordId});
  const [updateHomeBranch] = usePutServiceVehicleHomeBranchMutation();

  const userAccessibleBranch = currentUserInfo?.branches?.find(
    (branch) => branch.id === homeBranchQuery.data?.branchId
  );

  const {data: branchById} = useGetBranchQuery(
    {branchId: homeBranchQuery.data?.branchId ?? ''},
    {skip: isNil(homeBranchQuery.data?.branchId) || isNotNil(userAccessibleBranch)}
  );

  const activeBranch = userAccessibleBranch ?? branchById;

  const handleUpdateVehicleBranch = (branchId: string) =>
    updateHomeBranch({vehicleId: props.recordId, body: {branchId}}).unwrap().catch(handleApiError);

  return (
    <BranchChanger
      recordId={props.recordId}
      activeBranch={activeBranch}
      onChange={handleUpdateVehicleBranch}
      data-testid={props['data-testid']}
      tooltip={i18n.t('entity.controls.labels.service_branch.tooltip')}
    />
  );
}
